import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { AppCardList } from '@/common/components';
import { useGetAllProxyServersQuery } from '@/modules/ProxyServers/queries';

interface Props {
  currentPage: number;
  proxyServersListItems: BaseQueryParams<typeof useGetAllProxyServersQuery>['data']['items'];
  proxyServersListTotalItems: BaseQueryParams<typeof useGetAllProxyServersQuery>['data']['meta']['totalItems'];
  proxyServersListItemsPerPage: BaseQueryParams<typeof useGetAllProxyServersQuery>['data']['meta']['itemsPerPage'];
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const ProxyServersListView: FC<Props> = ({
  currentPage,
  proxyServersListItems,
  proxyServersListTotalItems,
  proxyServersListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  const domainRegistrarId = useParams()['*'];

  return (
    <AppCardList
      headerTitle={ null }
      pagination={{
        current: currentPage,
        total: proxyServersListTotalItems,
        pageSize: proxyServersListItemsPerPage,
        disabled: isLoading,
        onChange: (page: number) => handleChangePage(page)
      }}
      selectedKey={ domainRegistrarId }
      rowKey="id"
      titleKey="name"
      grid={{
        gutter: 16,
        xs: 1,
        sm: 1,
        md: 1,
        lg: 2,
        xl: 2,
        xxl: 3
      }}
      navigateTo={ (record) => ({ to: AppRoutes.ProxyServersById.replace(':proxyServerId', record.id) }) }
      list={ proxyServersListItems }
    />
  );

};
